/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  IMultiSend,
  IMultiSendInterface,
} from "../../../../contracts/periphery/Types.sol/IMultiSend";

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes",
        name: "transactions",
        type: "bytes",
      },
    ],
    name: "multiSend",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
] as const;

export class IMultiSend__factory {
  static readonly abi = _abi;
  static createInterface(): IMultiSendInterface {
    return new Interface(_abi) as IMultiSendInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): IMultiSend {
    return new Contract(address, _abi, runner) as unknown as IMultiSend;
  }
}
